// @flow

import { addCartProduct, getCart } from '@gandi/cart';

import type { Dispatch } from 'src/types';

import type { DomainProduct, PurchasableProcess } from '../../types';

import { getDomainCreateProductData, getTransferProductData } from './helpers';

export const addToCart =
  (props: {
    domain: DomainProduct,
    process: PurchasableProcess,
  }): ((dispatch: Dispatch) => any) =>
  async dispatch => {
    const { domain, process } = props;
    const { productData, extra } =
      process === 'transfer'
        ? getTransferProductData(domain)
        : getDomainCreateProductData(domain);

    // Add the product via the API, bypass dry-run.
    await dispatch(
      addCartProduct({
        productData,
        extra,
        options: { headers: { 'X-Dry-Run': 0 } },
      }),
    );

    dispatch(getCart());
  };
